<template>
    <div id="design-materials-sidebar-menu" class="sidebar-menu-container">
        <div>
<!--            <ProductCategories/>-->
            <CategoriesAndProductsSidebarMenu/>
        </div>
    </div>
</template>

<script>
    // import ProductCategories from "./DesignMaterialSidebarMenu/obsoleteProductCategories";
    import {bus} from "../../../vue_bus";
    import CategoriesAndProductsSidebarMenu from "./CategoriesAndProductsSidebarMenu";

    export default {
        name: "DesignMaterialSidebarMenu",
        components: {
            CategoriesAndProductsSidebarMenu,
            // ProductCategories,
        },
        mounted() {
            // bus.$on('productSelected', (productUUID) => {
            //     if (this.$store.state.route.params.idDesignGroup
            //         && this.$store.state.route.params.facadeElement) {
            //         this.$router.replace({
            //             name: "designMaterialsSelected",
            //             params: {productUUID: productUUID}
            //         }).catch(() => {
            //         })
            //     }
            // });
        },
        destroyed() {
            // bus.$off('productSelected');
        }
    }
</script>

<style scoped>
</style>
